/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {
  SPLIT_SDK_READY,
  SPLIT_SDK_READY_TIMED_OUT,
  SPLIT_SDK_UPDATE,
  FEATURES_UPDATED
} from './action-types.js';

import {
  FETCH_SUCCESS as FETCH_PROFILE_SUCCESS,
  UPDATE_SUCCESS as UPDATE_PROFILE_SUCCESS
} from 'modules/profile/action-types.js';
import * as Constants from './constants';
import { Flag, flagsToOrderedMap } from './types.js';

export const flags = (
  state: OrderedMap<string, typeof Flag> = flagsToOrderedMap(
    Constants.defaultTreatments
  ),
  action: Action<Object>
) => {
  const { type, payload } = action;

  switch (type) {
  case FEATURES_UPDATED:
    const x = flagsToOrderedMap(payload);
    return x;
  default:
    return state;
  }
};

export const loading = (state: boolean = false, action: Action<*>) => {
  switch (action.type) {
  case SPLIT_SDK_READY:
  case SPLIT_SDK_UPDATE:
    return true;
  case SPLIT_SDK_READY_TIMED_OUT:
  case FEATURES_UPDATED:
    return false;
  default:
    return state;
  }
};

export default combineReducers({
  flags,
  loading
});



// WEBPACK FOOTER //
// ./src/app/modules/features/stores.js